<!--
 * @Author: xuxiaofei
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @Description: 采购品类判断弹窗组件
 * @FilePath: \code\fe-mall\pages\index\src\routes\demand\index.vue
 -->
<template>
  <el-dialog
    :title="pageText.title"
    :visible.sync="dialogVisible"
    width="400px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <span>{{pageText.desc}}</span>
    <span slot="footer" class="dialog-footer">
      <Buttons size="mini" @click="cancelChange">{{pageText.cancelChange}}</Buttons>
      <Buttons size="mini" @click="ignore">{{pageText.ignore}}</Buttons>
      <Buttons type="primary" size="mini" @click="fillAgain">{{pageText.fillAgain}}</Buttons>
    </span>
  </el-dialog>
</template>

<script>
import Api from './api.js'
import GetData from './../../../../utils/response'
import { componentMessage } from './../../utils'
import { Buttons } from './../../../../index.js'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'DemandSubmissionEdit',
  components: {
    Buttons
  },
  props: {
	},
  data () {
    return {
      dialogVisible: false,
      sourcePurchaseCategoryId: null,
      targetPurchaseCategoryId: null,
      sourceData: {},
      targetData: {},
      rowIndex: null,
      pageText
    }
  },
  computed: {
  },
  watch: {
    
  },
  async created () {
    let verifyResult = componentMessage(['purchaser', 'mall'], '采购品类判断弹窗组件')
    if (verifyResult) return
  },
  methods: {
    // 判断采购品类模板是否相同
    async templateIsSame (sourceData, targetData, rowIndex) {
      this.sourceData = sourceData
      this.targetData = targetData
      this.sourcePurchaseCategoryId = sourceData.purchaseCategoryId
      let sysBizDataCode = sourceData.sysBizDataCode
      this.targetPurchaseCategoryId = targetData.purchaseCategoryId
      this.rowIndex = rowIndex
      let api = Api.templateIsSame
      let params = {
        sourcePurchaseCategoryId: this.sourcePurchaseCategoryId,
        targetPurchaseCategoryId: this.targetPurchaseCategoryId
      }
      let res = await GetData(this.$http(api.type, api.url, params))
      console.log(res)
      if (res.isOk) {
        // 对应模板不一致
        if (res.content === false) {
          // 有原始值或sysBizDataCode打开弹窗，没有则触发重新填写
          if (this.sourcePurchaseCategoryId || this.sourcePurchaseCategoryId === 0 || sysBizDataCode) {
            this.dialogVisible = true
          } else {
            this.fillAgain()
          }
        } else {
          // 当模板一致，直接触发忽略逻辑
          this.ignore()
        }
        
        
      }
    },
    // 取消变更,弹框消失，采购品类不修改
    cancelChange () {
      this.$emit('cancelChange', this.sourceData, this.rowIndex)
      this.dialogVisible = false
    },
    // 重新填写,弹窗消失，采购品类变更，自定义字段也按照最新的采购品类模板加载
    fillAgain () {
      this.$emit('fillAgain', this.targetData, this.rowIndex)
      this.dialogVisible = false
    },
    // 忽略，弹窗消失，采购品类变更，但自定义字段不更新
    ignore () {
      this.$emit('ignore', this.targetData, this.rowIndex)
      this.dialogVisible = false
    },
    // 关闭和取消变更逻辑一致
    handleClose(done) {
      this.cancelChange()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
